import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { Router } from '@angular/router';
import { AppStateService } from '../../init/app-state.service';
import { ProfileService } from '../../profile.service';
import { storageKeys } from 'src/app/app.constants';
import { HomeService } from '../../home.service';
import { CommonService } from '../../common.service';
import { NavController } from '@ionic/angular/standalone';
import { AlertServiceService } from 'src/app/alert-service.service';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HTTPErrorHandler {
  memberid : any;
  constructor(public storageService: StorageService,public router :Router, public appState: AppStateService, public profileService : ProfileService, public homeService: HomeService, public commonService : CommonService, public navCtrl : NavController, public alertService: AlertServiceService, public storage: Storage) { }

  public handleError(err: any) {
    //console.log("handler Error--->>>",JSON.stringify(err));
    if (err.status === 401) {
     // console.log('Session Expired')
      // TODO: Error Handling
      this.logout();
    }
    // else {
    //   this.alertService.errorAlertController(JSON.stringify(err));
    // }
    console.error('It happens: ', err);
  }

  logout(){
  this.anaymousApiHitWork();
  }

  public async anaymousApiHitWork() {
    storageKeys.localStorageKeys.forEach((key: any) => {
      localStorage.removeItem(key);
    });
    this.homeService.anaymousApiHit().then(res => {  //refactored code non-blocked task
      if (res) {
      //console.log("allResponse",res)
      this.appState.saveCsrftoken({
        csrftoken: res.headers.get('csrftoken'),
      });
      // const appData = this.appState.getAppData();
      //console.log('AppStateData ==>', appData);
      localStorage.removeItem(environment?.headers?.program_id + ":" + "ImageUrl");
      localStorage.removeItem(environment?.headers?.program_id + ":" + "imageUrlbase64");
      this.commonService.tab = 'home';
      this.commonService.isLoggedIn = false;
      this.profileService.profileData = null;
      this.storageService.remove(storageKeys.aemCachedData);
      this.storageService.remove(storageKeys.userDetails);
      this.storageService.remove(storageKeys.userType);
      this.storageService.remove(storageKeys.membershipNumber);
      this.storageService.remove(storageKeys.membershipTypeID);
      this.storageService.remove(storageKeys.memberType);
      this.storageService.remove(storageKeys.loginService);
      this.storageService.remove(storageKeys.signUpService);
      this.storageService.remove(storageKeys.mobileNumber);
      this.storageService.remove(storageKeys.emailID);
      this.storageService.remove(storageKeys.cartDetails);
      this.storageService.remove(storageKeys.membershipDetails);
      this.storageService.remove(storageKeys.homeDetails);
      this.storageService.remove(storageKeys.profileData);
      this.storageService.remove(storageKeys.giftCart);
      this.storageService.remove(storageKeys.userImage);
      this.storageService.remove(storageKeys.memberId);
      this.storageService.remove(storageKeys.enableScreenLock);
      this.storageService.remove(storageKeys.visitor);
      this.storageService.remove(storageKeys.atTheHotel);
      this.storageService.remove(storageKeys.csrftoken);
      this.storageService.remove(storageKeys.giftShownStatus);
      this.storageService.remove(storageKeys.recentSearchHotel);
      this.storageService.remove(storageKeys.propertiesList);
      localStorage.removeItem(environment?.headers?.program_id + ":" + "preferredLanguage");
      localStorage.removeItem(environment?.headers?.program_id + ":" + 'enableScreenLock');
      this.appState.clearAppState();
      this.homeService.refereshFlag = storageKeys.boolTrueValue;
      this.homeService.homeCrmData = {};
      this.navCtrl.navigateRoot(['/']);
      }
    }, err => {
      this.homeService.handleAPIError(err);
    })

  }
  

}

